// 
import Link from "next/link";
import { Assets } from "../list/Assets";
import Image from "next/image";
// 
export var menuIn = false;
export var searchIn = false;

export var searchInValue = function (value) {
  menuIn = value;
};

export var bothValue = function (value) {
  menuIn = value;
  searchIn = value;
};

export default function Logocom(props) {
  function search_in() {
    var Search_div = document.getElementsByClassName("Search_div");
    var black_screen = document.getElementById("black_screen");
    var menu = document.getElementsByClassName("menu");

    //menu_check();
    document.body.style.overflow = "hidden";
    Search_div[0].classList.remove("Sout");
    Search_div[0].classList.add("Sin");
    black_screen.style.display = "block";
    menu[0].className = "menu out";
    searchIn = true;
    menuIn = false;
  }

  function dropDown() {
    var logo_down = document.getElementsByClassName("logo-down");
    var menu = document.getElementsByClassName("menu");
    var black_screen = document.getElementById("black_screen");

    if (menuIn) {
      menuIn = false;
      menu[0].className = "menu out";
      setTimeout(function () {
        menu[0].scrollTop = 0;
      }, 250);
      document.body.style.overflow = "auto";
      black_screen.style.display = "none";
      logo_down[0].className = "logo-down down backtodown";
    } else {
      black_screen.style.display = "block";
      menu[0].className = "menu fade";
      document.body.style.overflow = "hidden";
      menuIn = true;
      logo_down[0].className = "logo-down up";
    }
  }

  function closeMenu() {
    var logo_down = document.getElementsByClassName("logo-down");
    var menu = document.getElementsByClassName("menu");
    var black_screen = document.getElementById("black_screen");
    menuIn = false;
    menu[0].className = "menu out";
    document.body.style.overflow = "auto";
    black_screen.style.display = "none";
    logo_down[0].className = "logo-down down backtodown";
  }

  function closeMenuFast() {
    var logo_down = document.getElementsByClassName("logo-down");
    var menu = document.getElementsByClassName("menu");
    var black_screen = document.getElementById("black_screen");
    menuIn = false;
    menu[0].className = "menu out2";
    document.body.style.overflow = "auto";
    black_screen.style.display = "none";
    logo_down[0].className = "logo-down down";
  }
  return (
    <div id="logo-container1">
      <div className="logo-flex">
        <nav className="logo-thumb">
          <Link href="/" prefetch={false} className="logo" onClick={closeMenu} passHref>
           
              <Image
                width="198px"
                height="101px"
                decoding="async"
                alt="logo"
                title="logo"
                src={Assets[0].logo}
              />
            
          </Link>
          <div className="logo-btns" >
            <Link href="/" className="logo-home" onClick={closeMenu} prefetch={false} passHref>
             
                <Image
                  width="40px"
                  height="40px"
                  decoding="async"
                  alt="Home Icon"
                  title="Home"
                  src={Assets[0].home}
                />
             
            </Link>
            <div className="logo-down down" onClick={dropDown} >
              <Image
                width="40px"
                height="40px"
                decoding="async"
                alt="Drop down icon"
                title="Drop down icon"
                src={Assets[0].drop_down_icon}
              />
            </div>
          </div>

          <div className="menu out">
            <div className="list">
              <div className="items" title="search" onClick={search_in}>
                <Image
                  decoding="async"
                  alt="search icon"
                  title="search icon"
                  width="28px"
                  height="28px"
                  src={Assets[0].searchIcon}
                ></Image>
                <div className="menutext">Search</div>
              </div>
              <Link href={"/categories/exclusive-games"} prefetch={false} className="items" title="Exclusive Games" onClick={closeMenuFast} passHref>
                
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].exclusiveIcon}
                  ></Image>
                  <div className="menutext">Exclusive Games</div>
                
              </Link>
              <Link href={"/categories/princess-games"} prefetch={false} className="items" title="Princess Games" onClick={closeMenuFast} passHref>
               
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].princessIcon}
                  ></Image>
                  <div className="menutext">Princess Games</div>
                
              </Link>
              <Link href={"/categories/dress-up-games"} prefetch={false} className="items" title="Dress Up Games" onClick={closeMenuFast} passHref>
                
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].dressUpGames}
                  ></Image>
                  <div className="menutext">Dress Up Games</div>
                
              </Link>
              <Link href={"/categories/makeover-games"} prefetch={false} className="items" title="Makeover Games" onClick={closeMenuFast} passHref>
               
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].makeoverGames}
                  ></Image>
                  <div className="menutext">Makeover Games</div>
               
              </Link>
              <Link href={"/categories/decoration-games"} prefetch={false} className="items" title="Decoration Games" onClick={closeMenuFast} passHref>
               
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].decorationGames}
                  ></Image>
                  <div className="menutext">Decoration Games</div>
               
              </Link>
              <Link href={"/categories/wedding-games"} prefetch={false} className="items" title="Wedding Games" onClick={closeMenuFast} passHref>
               
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].weddingGames}
                  ></Image>
                  <div className="menutext">Wedding Games</div>
              
              </Link>
              <Link href={"/categories/celebrity-games"} prefetch={false} className="items" title="Celebrity Games" onClick={closeMenuFast} passHref>
                
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].celebrityGames}
                  ></Image>
                  <div className="menutext">Celebrity Games</div>
              
              </Link>
              <Link href={"/categories/cooking-games"} prefetch={false} className="items" title="Cooking Games" onClick={closeMenuFast} passHref>
                
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].cookingGames}
                  ></Image>
                  <div className="menutext">Cooking Games</div>
               
              </Link>
              <Link href={"/categories/doctor-games"} prefetch={false} className="items" title="doctorGames" onClick={closeMenuFast} passHref>
               
                  <Image
                    decoding="async"
                    alt="search icon"
                    title="search icon"
                    width="28px"
                    height="28px"
                    src={Assets[0].doctorGames}
                  ></Image>
                  <div className="menutext">Doctor Games</div>
                
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}